/**
 * Site Name Configuration
 * Auto-generated from: KEYWORD + NICHE + COUNTRY
 * Format: {keyword} {niche} {country}
 * This file is auto-generated - do not edit manually
 * 
 * Generated at: 2026-01-27T19:12:14.736Z
 */

// Site name auto-generated from keyword, niche, and country
export const SITE_NAME = 'treffen mature deutschland'

export default SITE_NAME
